<template>
  <div class="page-wrapper">
    <div class="d-flex align-center pa-4">
      <h1 class="text-h6">
        {{ $t('popup_banners') }}
      </h1>
      <v-spacer />
      <BasePrimaryActionButton
        :label="$t('create_popup_banner')"
        @click="$router.push({ name: 'createPopupBanner' })"
      />
    </div>

    <BaseTableLoader :loading="!popupBanners">
      <PopupBannerTable
        :items="popupBanners"
        :pagination="popupBannerPagination"
        :loading="loadingPopupBanners"
        @edit="$router.push({ name: 'editPopupBanner', params: { id: $event.id } })"
        @update:page="onPageChange"
        @delete="deletePopupBanner"
      />
    </BaseTableLoader>

    <router-view @click:close="closeDialog" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseTableLoader from '../../components/base/BaseTableLoader';
import BasePrimaryActionButton from '../../components/base/BasePrimaryActionButton';
import PopupBannerTable from '../../components/PopupBannerTable';

export default {
  name: 'PopupBanner',

  components: { BaseTableLoader, BasePrimaryActionButton, PopupBannerTable },

  created() {
    if (!this.popupBanner) {
      this.fetchPopupBanners(this.$route.query);
    }
  },

  beforeRouteUpdate(to, from, next) {
    if (
      JSON.stringify(this.popupBannerFilterParams) !== JSON.stringify(to.query) &&
      to.name === 'popupBanner'
    ) {
      this.fetchPopupBanners(to.query);
    }
    next();
  },

  computed: mapState('popupBanners', [
    'popupBanners',
    'popupBannerPagination',
    'popupBannerFilterParams',
    'loadingPopupBanners',
    'savingPopupBanner',
  ]),

  methods: {
    ...mapActions('popupBanners', [
      'fetchPopupBanners',
      'storePopupBanner',
      'updatePopupBanner',
      'deletePopupBanner',
    ]),

    onPageChange(page) {
      const query = { ...this.popupBannerFilterParams, page };
      this.$router.push({ name: 'popupBanner', query });
    },

    viewImage(image) {
      this.$router.push({ name: 'popupBanner/images', params: { url: image.image_path } });
    },

    viewDescription(event) {
      this.$router.push({
        name: 'popupBanner/text',
        params: { id: event.id },
      });
    },

    setStoryDisplayed(event, story) {
      const editedStory = { ...story, show_in_homepage: event };
      this.updatePopupBanner(editedStory);
    },

    closeDialog() {
      this.$router.push({ name: 'popupBanners', query: this.popupBannerFilterParams });
    },
  },
};
</script>
